import Model from './base';

export class CarModelDetailMaker extends Model {
  resource() {
    return 'catalog/car-model-detail-maker';
  }

  defaultAttributes() {
    return {
      name: null,
    }
  }
}

export class CarMark extends Model {
  resource() {
    return 'catalog/car-mark';
  }

  defaultAttributes() {
    return {
      name: null,
    }
  }
}

export class CarModelDetail extends Model {
  resource() {
    return 'catalog/car-model-detail';
  }

  defaultAttributes() {
    return {
      modification: null,
      date_start: null,
      date_end: null,
      engine: null,
      power_kw: null,
      power_hp: null,
      model: null,
      vehicle_type: null,
      vehicle_body: null,
      makers: [],
    }
  }
}
